// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'


const PageConst= {
  ACTION: {
    doAdd: { api: 'T2010TeacherBasicService.C10101_doAdd'},
    getEdit: { api: 'T2010TeacherBasicService.C10101_getEdit'},
    doEdit: { api: 'T2010TeacherBasicService.C10101_doEdit'},
    doRead: { api: 'T2010TeacherBasicService.doRead'},
    doDelete: { api: 'T2010TeacherBasicService.doDelete'},
    doBrowse: { api: 'T2010TeacherBasicService.C10101_doBrowse'},
    getTableColumnDefsDataForSearchTable: { api: 'T2010TeacherBasicService.getTableColumnDefsDataForSearchTable'},
    getTableColumnDefsDataForAtForm: { api: 'T2010TeacherBasicService.getTableColumnDefsDataForAtForm'},
  },
}

const module = {
  state: {
    PageConst
  },

  getters: {

  },

  mutations: {

  },
  actions: {
    async getDropdownData ({ commit,state }, payload) {
      const res = await ApiUtils.postData({ data: [
        {
          api: 'T2010TeacherBasicService.C10101_getDropdownData'
        }
      ] })
      return res[0].output
    }
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
